export default "__VITE_ASSET__DEMK3MQ1__"